async function apiCall({endpoint, method, body, params}) {
    let token = ''
    if (localStorage.getItem('user')) {
        token = JSON.parse(localStorage.getItem('user')).token;
    }
    if (params !== undefined) {
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([, v]) => v !== undefined && v !== null)
        );
        let url_encoded_params = new URLSearchParams(cleanParams);
        endpoint = `${endpoint}?${url_encoded_params.toString()}`
    }
    let response = new Promise((resolve, reject) => {
        fetch(`/api/${endpoint}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: body !== undefined ? JSON.stringify(body) : null
        }).then((r) => {
        if (r.ok) {
            r.json().then((r) => resolve(r));
        } else {
            r.json().then((r) => reject(r.detail)).catch((e) => reject({status: r.status, detail: r.statusText}));
        }
        });
    })
    return response;
}

export { apiCall };